import { TimeService_timeServiceGetGetTime } from '@festina/legalentity-general-types/legalentity-test/hooks/TimeService_timeServiceGetGetTime'

export const useFetchLegalEntityTime =
  TimeService_timeServiceGetGetTime.useQuery
